import { get } from '../../base';

import { PosProfileResponse } from './types-get-one';

export function getPosProfileById(authToken?: string): Promise<PosProfileResponse> {
  const headers = authToken ? { authorization: `Bearer ${authToken}` } : undefined;
  return get(`v5/pos/profile`, { headers }).json<PosProfileResponse>();
}
